import { put, takeLatest, delay } from "redux-saga/effects";
import { postCreateNewPasswordApi } from "store/api/LoginApi";
import { CREATE_NEW_PASSWORD_ACTION } from "../../actions/LoginPageAction/actionTypes";

import * as globalAction from "../../actions/GlobalAction";

function* showMessage(isError, message) {
	const alert = { isError: isError, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* postCreateNewPassword(action) {
	yield put(globalAction.openLoadingPage());
	const { data, onSuccess } = action.params;

	const res = yield postCreateNewPasswordApi(data);
	try {
		if (res?.code === 0) {
			onSuccess();
			yield showMessage(false, res?.message);
		} else {
			yield showMessage(true, res?.message);
		}
		yield delay(500);
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* postCreateNewPasswordSaga() {
	yield takeLatest(CREATE_NEW_PASSWORD_ACTION, postCreateNewPassword);
}

export default postCreateNewPasswordSaga;
